import React from "react";
import Modal from "react-modal";

Modal.setAppElement("#root");

const PaymentModal = ({
  isOpen,
  onRequestClose,
  onConfirm,
  status,
  loading = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="fixed inset-0 flex items-center justify-center"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50"
      contentLabel="Confirmation Modal"
    >
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-xl font-bold mb-4">Confirmation</h2>

        <p className="mb-6">
          {status === "pay"
            ? "Are you sure you want to pay this driver?"
            : "Are you sure you want to cancel this request?"}
        </p>

        <div className="flex justify-end space-x-4">
          <button
            onClick={onRequestClose}
            className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded-md"
            disabled={loading}
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            className={`px-4 py-2 text-white rounded-md flex items-center ${
              status === "pay"
                ? "text-primary bg-celadon"
                : "bg-red-500 hover:bg-red-600"
            }`}
            disabled={loading}
          >
            {loading ? (
              <>
                <svg
                  className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                {status === "pay" ? "Processing..." : "Cancelling..."}
              </>
            ) : (
              "Yes"
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentModal;
